import Revision from '../../revision';
import BlockerMessage from './message';
import BlockerButton from './button';
import LocationAdapter from '../../adapters/location_adapter';
import { PlayerEnvironment } from '../../player_environment';
import VideoHelpers from '../../utils/video_helpers';
import BlockerSignIn from './sign_in';
import TopicAdapter from '../../adapters/topic_adapter';
import FullscreenApiAdapter from '../../adapters/fullscreen_api_adapter';

export default class Blocker {
  constructor(options = {}) {
    this._tech = options.tech;
    this._data = options.data;
    this._userFeedback = options.userFeedback;
    this._exploreVidio = options.exploreVidio;
    this._isShown = false;
    this._blockerSignIn = new BlockerSignIn({ tech: options.tech });
    this._uuid = options.uuid;
  }

  get uuid() {
    return this._uuid;
  }
  get tech() {
    return this._tech;
  }
  get data() {
    return this._data;
  }
  get userFeedback() {
    return this._userFeedback;
  }
  get genericErrorPrefix() {
    return Revision.tag().replace('PLAYBACK-', '');
  }
  get isShown() {
    return this._isShown;
  }

  blockerSignIn() {
    return this._blockerSignIn;
  }

  render(errorType) {
    const element = document.createElement('div');
    element.className = 'vjs-player-error__section';
    element.innerHTML = `<div class="vjs-player-error__container">
      <div class="vjs-player-error__header">
        <div class="vjs-player-error__icon vjs-player-error__${errorType.iconClass}"></div>
        <h3 class="vjs-player-error__title">${errorType.title}</h3>
        <div class="vjs-player-error__body" data-desktop-subtitle="${errorType.desktopSubTitle}" data-mobile-subtitle="${errorType.mobileSubTitle}"></div>
        <div class="vjs-player-error__cta"></div>
      </div>
    </div>`;

    let cta = element.querySelector('.vjs-player-error__cta');
    let container = element.querySelector('.vjs-player-error__container');

    container.appendChild(this.closeButton('.vjs-player-error__section'));
    if (errorType.enableRetry) cta.appendChild(this.retryButton(false, 'Retry again'));
    cta.appendChild(this.downloadButton());
    cta.appendChild(this.feedbackButton());

    return element;
  }

  renderBlocker2ButtonCta(message, blockerName, ctaButtons = [], haveCloseButton = true) {
    const element = document.createElement('div');
    element.className = 'vjs-player-error__section';
    element.innerHTML = `<div class="vjs-player-error__container">
      <div class="vjs-player-error__header">
        <h3 class="vjs-player-error__title-revamp">${message.title}</h3>
        <div class="vjs-player-error__subtitle-revamp">${message.subtitle}</div>
        <div class="vjs-player-error__btn-container"></div>
      </div>
    </div>`;
    element.style.backgroundImage = "url('" + this.data?.videoBlockerImageUrl() + "')";

    let ctaContainer = element.querySelector('.vjs-player-error__btn-container');
    let container = element.querySelector('.vjs-player-error__container');

    if (haveCloseButton) {
      container.appendChild(this.closeButton('.vjs-player-error__section'));
    }

    ctaButtons.forEach(button => {
      ctaContainer.appendChild(button);
    });

    return element
  }

  renderBlocker1ButtonCta(message) {
    const element = document.createElement('div');
    element.className = 'vjs-generic-error';
    element.innerHTML = `<div class="vjs-generic-error-container">
      <h3 class="vjs-generic-error-title-revamp">${message.title}</h3>
      <h3 class="vjs-generic-error-subtitle-revamp">${message.subtitle}</h3>
      <p class="vjs-generic-play-uid">(Play UID: ${this._uuid})</p>
      <div class="vjs-generic-error-wrapper"></div>
    </div>`;

    let container = element.querySelector('.vjs-generic-error-wrapper');

    element.appendChild(this.closeButton('.vjs-generic-error'));
    container.appendChild(this.retryButton(true, message.cta));
    container.appendChild(this.generalReportButton(message.labelAdditionalCta, message.additionalCta));

    return element
  }

  renderGeoblock(message) {
    const errorType = 'geoblock';
    const supportLink = "https://support.vidio.com/support/solutions/articles/43000656971-mengapa-konten-tidak-tersedia-di-negara-saya"

    let ctaButtons = [];
    ctaButtons.push(this.exploreVidioButton(message.cta))
    ctaButtons.push(this.withDirectLinkButton(message.additionalCta,supportLink,'additionalWhiteCta-button'));
    
    return this.renderBlocker2ButtonCta(message, errorType, ctaButtons);
  }

  renderNetworkIssue(message) {
    const errorType = 'network';
    const supportLink = 'https://support.vidio.com/support/solutions/articles/43000656970-bagaimana-memecahkan-masalah-jaringan'

    let ctaButtons = [];
    ctaButtons.push(this.retryButton(true, message.cta))
    ctaButtons.push(this.withDirectLinkButton(message.additionalCta,supportLink,'additionalWhiteCta-button'));

    return this.renderBlocker2ButtonCta(message, errorType, ctaButtons);
  }

  renderMediaIssue(message) {
    const errorType = 'media';
    const supportLink = 'https://support.vidio.com/support/solutions/articles/43000656973-mengapa-saya-tidak-dapat-memproses-media'

    let ctaButtons = [];
    ctaButtons.push(this.reportButton(message.cta, 3))
    ctaButtons.push(this.withDirectLinkButton(message.additionalCta,supportLink,'additionalWhiteCta-button'));

    return this.renderBlocker2ButtonCta(message, errorType, ctaButtons);
  }

  renderDRMIssue(message) {
    const errorType = 'drm';
    const supportLink = "https://support.vidio.com/support/solutions/articles/43000656969-apa-itu-drm"

    let ctaButtons = [];
    ctaButtons.push(this.exploreVidioButton(message.cta))
    ctaButtons.push(this.withDirectLinkButton(message.additionalCta,supportLink,'additionalWhiteCta-button'));
    
    return this.renderBlocker2ButtonCta(message, errorType, ctaButtons);
  }

  renderGeneralError(message) {
    return this.renderBlocker1ButtonCta(message);
  }

  renderFetchingError(message) {
    return this.renderBlocker1ButtonCta(message);
  }

  renderMediaNotSupported(message) {
    const errorType = 'not-supported-media';
    const supportLink = "https://support.vidio.com/support/solutions/articles/43000656974-bagaimana-memecahkan-kendala-perangkat"

    let ctaButtons = [];
    ctaButtons.push(this.reportButton(message.cta, 4))
    ctaButtons.push(this.withDirectLinkButton(message.additionalCta,supportLink,'additionalWhiteCta-button'));

    return this.renderBlocker2ButtonCta(message, errorType, ctaButtons);
  }

  renderGenericError(errorCode) {
    const element = document.createElement('div');
    element.className = 'vjs-generic-error';
    element.innerHTML = `<div class="vjs-generic-error-container">
      <img class="vjs-generic-error-icon" src="https://static-playback.prod.vidiocdn.com/images/illustration-error-general.svg" />
      <h3 class="vjs-generic-error-title">Oops! Terjadi Kendala</h3>
      <p class="vjs-generic-error-code">(Report code: ${this.genericErrorPrefix}:${errorCode})</p>
      <div class="vjs-generic-error-cta"></div>
    </div>`;

    let cta = element.querySelector('.vjs-generic-error-cta');

    element.appendChild(this.closeButton('.vjs-generic-error'));

    if (PlayerEnvironment.isMobileSite()) {
      cta.appendChild(this.downloadButton());
    } else {
      cta.appendChild(this.feedbackButton());
    }

    cta.appendChild(this.retryButton(false, 'Retry again'));

    return element;
  }

  showMessage(dom) {
    const vjsContainerEl = document.querySelector('.video-js');
    if (vjsContainerEl) {
      vjsContainerEl.appendChild(dom);
      this._isShown = true;
    }
  }

  closeButton(parentElement) {
    let element = document.createElement('button');
    element.className = 'vjs-player-error__close-btn';
    element.innerHTML = '&times;';
    element.onclick = this.onCloseButtonClick(parentElement);
    return element;
  }

  retryButton(revamp, text) {
    if (revamp == true) {
      return BlockerButton.createRevamp(
        'additionalCta-button',
        text,
        this.onClickRetryButton.bind(this),
        {},
        'white'
      );
    } else {
      return BlockerButton.create(
        'retry',
        text,
        this.onClickRetryButton.bind(this)
      );
    }
  }

  downloadButton() {
    let downloadLink = 'https://app.vidio.com/appdownload-errorblocker';
    return BlockerButton.create(
      'download',
      'Download App',
      this.onClickDownloadButton.bind(this),
      { href: downloadLink }
    );
  }

  feedbackButton() {
    return BlockerButton.create(
      'feedback',
      'Send feedback',
      this.onClickFeedbackButton.bind(this)
    );
  }

  exploreVidioButton(text) {
    let exploreVidioLink = 'https://www.vidio.com';
    return BlockerButton.createRevamp(
      'additionalCta-button',
      text,
      this.onClickHrefButton.bind(this),
      { href: exploreVidioLink },
      'white'
    );
  }

  reportButton(text, code) {
    return BlockerButton.createRevamp(
      'cta-button',
      text,
      this.onclickReportButton.bind(this, code)
    );
  }

  generalReportButton(textLabel, text) {
    return BlockerButton.createButtonReportWithLabel(
      'general-additionalCta',
      textLabel,
      text,
      this.onclickReportButton.bind(this)
    );
  }

  detailErrorButton(text, type) {
    return this.withLinkButton(text, type, 'additionalCta-button');
  }

  withLinkButton(text, type, customClass) {
    let href;
    switch (type) {
      case 'geoblock':
        href =
          'https://support.vidio.com/support/solutions/articles/43000656971-mengapa-konten-tidak-tersedia-di-negara-saya';
        break;
      case 'media':
        href =
          'https://support.vidio.com/support/solutions/articles/43000656973-mengapa-saya-tidak-dapat-memproses-media';
        break;
      case 'network':
        href =
          'https://support.vidio.com/support/solutions/articles/43000656970-bagaimana-memecahkan-masalah-jaringan';
        break;
      case 'drm':
        href =
          'https://support.vidio.com/support/solutions/articles/43000656969-apa-itu-drm';
        break;
      case 'hdcp':
        href =
          'https://support.vidio.com/support/solutions/articles/43000642152-hdcp-information;'
      case 'not-supported-media':
        href =
          'https://support.vidio.com/support/solutions/articles/43000656974-bagaimana-memecahkan-kendala-perangkat';
        break;
      default:
        null;
        break;
    }
    return this.withDirectLinkButton(text, href, customClass);
  }

  withDirectLinkButton(text, href, customClass) {
    return BlockerButton.createRevamp(
      customClass,
      text,
      this.onClickHrefButton.bind(this),
      { href: href }
    );
  }

  onCloseButtonClick(element) {
    return () => {
      let blockerElement = document.querySelector(element);

      blockerElement.parentNode.removeChild(blockerElement);
      this.tech.error(null);
      this._isShown = false;
    };
  }

  showNetworkIssueMessage() {
    const lang = VideoHelpers.getLang();
    const dom = this.renderNetworkIssue(
      BlockerMessage.typeErrorNetworkIssue(lang)
    );
    this.showMessage(dom);
  }

  showMediaIssueMessage() {
    const lang = VideoHelpers.getLang();
    const dom = this.renderMediaIssue(
      BlockerMessage.typeErrorMediaIssue(lang)
    );
    this.showMessage(dom);
  }

  showDRMIssueMessage() {
    const lang = VideoHelpers.getLang();
    const dom = this.renderDRMIssue(
      BlockerMessage.typeErrorDRMIssue(lang)
    );
    this.showMessage(dom);
  }

  showGenericError(errorCode) {
    const dom = this.renderGenericError(errorCode);
    this.showMessage(dom);
  }

  showGeneralError() {
    const lang = VideoHelpers.getLang();
    const dom = this.renderGeneralError(
      BlockerMessage.typeErrorGeneralIssue(lang)
    );
    this.showMessage(dom);
  }

  showFetchingError() {
    const lang = VideoHelpers.getLang();
    const dom = this.renderFetchingError(
      BlockerMessage.typeErrorFetching(lang)
    );
    this.showMessage(dom);
  }

  showMediaNotSupported() {
    const lang = VideoHelpers.getLang();
    const dom = this.renderMediaNotSupported(
      BlockerMessage.typeMediaNotSupported(lang)
    );
    this.showMessage(dom);
  }

  showNotSupportedMessage() {
    const vod_player = document.querySelector('#' + this.data.playerId());
    if (vod_player)
      vod_player.classList.add(
        'video-js',
        'vjs-fluid',
        'vod-player-dimensions'
      );

    const dom = this.render(BlockerMessage.typeNotSupported());
    this.showMessage(dom);
  }

  showGeoblockMessage() {
    const vod_player = document.querySelector('#' + this.data.playerId());
    if (vod_player)
      vod_player.classList.add(
        'video-js',
        'vjs-fluid',
        'vod-player-dimensions'
      );

    const lang = VideoHelpers.getLang();
    let dom = this.renderGeoblock(
      BlockerMessage.typeErrorGeoblock(lang)
    );
    this.showMessage(dom);
  }

  onClickDownloadButton() {
    let type;
    if (this.data.isVideo()) type = 'vp-download-app-button-click';
    if (this.data.isLivestreaming())
      type = 'vp-livestream-download-app-button-click';

    this.tech.trigger({ type });
  }

  onClickHrefButton() {
    let type;
    if (this.data.isVideo()) type = 'vp-href-button-click';
    if (this.data.isLivestreaming()) type = 'vp-livestream-href-button-click';

    this.tech.trigger({ type });
  }

  onClickRetryButton() {
    let type;
    if (this.data.isVideo()) type = 'vp-retry-button-click';
    if (this.data.isLivestreaming()) type = 'vp-livestream-retry-button-click';

    this.tech.trigger({ type });
    LocationAdapter.reload();
  }

  onClickFeedbackButton() {
    let type;

    if (this.data.isVideo()) type = 'vp-feedback-button-click';
    if (this.data.isLivestreaming())
      type = 'vp-livestream-feedback-button-click';

    this.tech.trigger({ type });

    if (PlayerEnvironment.isMobileSite()) {
      this.sendUserFeedback();
    } else {
      this.userFeedback.handlePlayerIssueFeedback();
    }
  }

  waitFullscreenExited(interval) {
    return new Promise(resolve => {
      const exitFsInterval = setInterval(() => {
        if (!this.tech.isFullscreen()) {
          clearInterval(exitFsInterval)
          resolve()
        }
      }, interval);
    })
  }

  publishSendFeedbackTopic(code) {
    TopicAdapter.publish('watchpage/send_feedback/video_playback', { code: String(code) })
  }

  onclickReportButton(code) {
    let type;

    if (this.data.isVideo()) type = 'vp-report-button-click';
    if (this.data.isLivestreaming()) type = 'vp-livestream-report-button-click';

    this.tech.trigger({ type });


    if (PlayerEnvironment.isMobileSite() && (code == 3 || code == 4)) {
      if (this.tech.isFullscreen()) {
        FullscreenApiAdapter.exitFullscreen();
        this.waitFullscreenExited(10).then(() => this.publishSendFeedbackTopic(code))
      } else {
        this.publishSendFeedbackTopic(code)
      }
    } else if (PlayerEnvironment.isMobileSite()) {
       this.sendUserFeedback();
    } else {
      this.userFeedback.handlePlayerIssueFeedback();
    }
  }

  sendUserFeedback() {
    window.setTimeout(() => {
      this.userFeedback.sendUserFeedback();
    }, 300);
  }

  showSignInBlocker() {
    this.blockerSignIn().show();
  }
}
